/**
 * 国际市场（/international）字段模型
 * 后台按区块分组展示可编辑字段（中文 label + 类型 + 默认值），前端用 $C(scope, key, default) 读取。
 * 注：拍卖结果 / 价格 / 产品 / 最新动态等结构化数据均由后端接口运行时拉取（非硬编码），
 * 故此处只接管页面可见的中文文案与可替换的背景图。
 */
export default {
  title: '国际市场',
  groups: [
    {
      title: '拍卖结果区块',
      fields: [
        { key: 'auctionTitle', label: '区块标题·拍卖结果', type: 'text', default: '拍卖结果' },
        { key: 'gdtLinkText', label: 'Go GDT 按钮文字', type: 'text', default: 'Go GDT' },
      ],
    },
    {
      title: 'GDT 价格指数变化区块',
      fields: [
        { key: 'priceIndexTitle', label: '区块标题·GDT 价格指数变化', type: 'text', default: 'GDT 价格指数变化' },
        { key: 'priceIndexLink', label: '查看10年链接文字', type: 'text', default: '查看 10年以来的GDT 价格指数' },
        { key: 'tenYearTitle', label: '十年价格弹窗标题', type: 'text', default: '10年以来的GDT 价格指数' },
      ],
    },
    {
      title: '产品区块',
      fields: [
        { key: 'productTitle', label: '区块标题·产品', type: 'text', default: '产品' },
      ],
    },
    {
      title: '最新动态区块',
      fields: [
        { key: 'newsTitle', label: '区块标题·最新动态', type: 'text', default: '最新动态' },
        { key: 'productTitleSep', label: '产品弹窗标题分隔符', type: 'text', default: '—拍卖结果' },
      ],
    },
    {
      title: '图片与视频',
      fields: [
        { key: 'pageBg', label: '页面背景图（覆盖默认背景）', type: 'image', default: '' },
      ],
    },
  ],
}
